import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { colors } from 'styles/variables';
import { createContinueBtn } from './continueBtn';
import resultsPassed from 'assets/Correct_loop.gif';
import resultsFailed from 'assets/Incorrect_loop.gif';
import { createMediaBlock } from './media';
import { getSId } from '../utils';
import { getPlaceholderText } from './text';

const { lPink } = colors;

export type ResultsPageProps = InteractionProps & {
  //
};

export const createResultsPageContentBlock = (count: number) => {
  return createBlock('ResultsPageContent', [
    createBlock('ResultsPageContentPassed', [
      createMediaBlock({
        child: 0,
        textPlaceholderContent: getPlaceholderText('h2', 'heading-two'),
        className: 'text-align-center',
      }),
      createMediaBlock({
        src: resultsPassed,
        type: 'passed',
        child: 1,
        useBackgroundControls: true,
      }),
    ]),
    createBlock('ResultsPageContentFailed', [
      createMediaBlock({
        child: 0,
        textPlaceholderContent: getPlaceholderText('h2', 'heading-two'),
        className: 'text-align-center',
      }),
      createMediaBlock({
        src: resultsFailed,
        type: 'failed',
        child: 1,
        useBackgroundControls: true,
      }),
    ]),
  ]);
};

export const createResultsPageMediaBlock = (count: number) => {
  return createBlock('ResultsPageMedia', [
    createMediaBlock({
      src: resultsPassed,
      type: 'passed',
      child: 1,
      useBackgroundControls: true,
    }),
    createMediaBlock({
      src: resultsFailed,
      type: 'failed',
      child: 1,
      useBackgroundControls: true,
    }),
  ]);
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createResultsPageContentBlock(0),
    () =>
      createBlock('InteractionColumn', [
        createBlock('ResultsPageResult'),
        createMediaBlock({
          child: 0,
          isAdditionalMedia: true,
        }),
      ]),
  ][i];
};

export const createResultsPageInteractionBlock = (props: ResultsPageProps) => {
  const {
    graphType = 'circle',
    graphColor = '#D1D5E7' || lPink,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(0), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'ResultsPage',
        name: props.name,
        sId: getSId('interaction'),
        graphType,
        graphColor,
        style: props.style,
      },
      meta: {
        subType: 'ResultsPage',
        layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
          props.columnsReversed ? 'Reversed' : ''
        }`,
      },
    }
  );
};

export const create = createResultsPageInteractionBlock;
export const interactionConfig = {};
